import { writable } from "svelte/store";
import { base } from "../utils/base";
// Initial dataset
const initialDataset = [
  {
    id: 6,
    dataset: "Land Cover of HKH 2022",
    description: "Land cover of Hindu Kush Himalayan (HKH) region",
    mapservice_rest_url: [
      {
        name: "Land Cover 2022",
        mapserver: "arcgis",
        layerIndex: 21,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Landcover/MapServer",
      },
    ],
    category: "Land Cover",
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=1972511",
    application_link: "https://geoapps.icimod.org/rlcms",
    paragraph:
      "The dataset showcases the land cover of Hindu Kush Himalaya (HKH) region for 2022. The dataset is part of the annual land cover datasets (2000 – 2022) for HKH produced by ICIMOD’s SERVIR-HKH initiative under its the Regional Land Cover Monitoring System (RLCMS). The datasets have been produced using advanced remote sensing technology on Google Earth Engine following a harmonized classification scheme and robust methodologies.",
    thumbnail:
      "https://rds.icimod.org/Content/metadataImage/1972500-1972599/1972511/public/rlcms.png",
  },
  {
    id: 21,
    // "mapserver": "arcgis",
    dataset: "Landslides in HKH",
    description: "Landslides Occurence in Hindu Kush Himalaya",
    category: "Disaster",
    // "mapservice_rest_url": "",
    mapservice_rest_url: [
      {
        name: "Landslides",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Landslide/MapServer",
      },
    ],
    // "layerIndex":0,
    rds_link:
      "https://maps.nccs.nasa.gov/arcgis/apps/MapAndAppGallery/index.html?appid=574f26408683485799d02e857e5d9521 ",
    application_link: "http://geoapps.icimod.org/resourcesinfo/",
    paragraph:
      "The dataset showcases the landslide incidents occurring in the HKH region between 2014 and 2024. The dataset has been compiled from NASA’s global landslide catalog.",
    thumbnail: `${base}/images/thumbnail/21.png`,
  },
  {
    id: 8,
    // "mapserver": "arcgis",
    dataset: "Glacier in the HKH",
    description: "Status of Glaciers in Hindu Kush Himalayan (HKH) Region",
    category: "Glacier",
    // "mapservice_rest_url": "",
    mapservice_rest_url: [
      {
        name: "Glacier in the HKH",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Glacier/MapServer",
      },
    ],
    //"layerIndex":0,
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=9359",
    application_link: "https://geoapps.icimod.org/glacier/hkhglacier/ ",
    paragraph:
      "This dataset provides information on the status of glaciers in the Hindu Kush Himalaya (HKH) region for the period 2005 ± 3 years (2002-2008). It was developed using Landsat ETM+ imageries from the corresponding years. The glacier outlines were derived through a semi-automated process involving the object-based image classification (OBIC) method, applied separately for clean ice and debris-covered areas. Further editing and validation were performed by overlaying the outlines on high-resolution images from Google Earth. Attribute data were assigned to each glacier using the 90-meter resolution SRTM DEM.Source: ICIMOD and CAREERI. The data for the Chinese part of the HKH region is a product of a national project conducted by the Ministry of Science and Technology of China (Grant No. 2006FY110200). ",
    thumbnail: `${base}/images/thumbnail/8.png`,
  },

  {
    id: 9,
    // "mapserver": "arcgis",
    dataset: "Earthquake in HKH",
    description: "",
    category: "Disaster",
    // "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Earthquake/MapServer",
    mapservice_rest_url: [
      {
        name: "Earthquake in HKH",
        mapserver: "arcgis",
        layerIndex: 1,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Earthquake/MapServer",
      },
    ],
    // "layerIndex":1,
    rds_link: "",
    application_link: "https://earthquake.usgs.gov/earthquakes/search/",
    paragraph:
      "This dataset provides information on the earthquake incidents with Magnitude > 5.0 occurring in the HKH region between 1971 and 2024. The data has been acquired from United States Geological Survey (USGS).",
    thumbnail: `${base}/images/thumbnail/9.png`,
  },
  {
    id: 22,
    // "mapserver": "geoserver",
    dataset: "Hydropower Plants in HKH",
    description: "",
    category: "Energy",
    mapservice_rest_url: [
      {
        name: "Operational",
        mapserver: "arcgis",
        layerIndex: "0",
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/HydropowerPlant/MapServer",
      },
      {
        name: "Under Construction",
        mapserver: "arcgis",
        layerIndex: "1",
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/HydropowerPlant/MapServer",
      },
      {
        name: "Planned",
        mapserver: "arcgis",
        layerIndex: "2",
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/HydropowerPlant/MapServer",
      },
    ],

    // "layerIndex":0,
    rds_link: "",
    application_link: "",
    paragraph:
      "This dataset provides information on hydropower plants in the HKH region, classified into three categories: operational (currently in operation), under construction (with a construction license), and planned (applied for a construction license). The dataset includes projects with a capacity greater than 1 MW.",
    thumbnail: `${base}/images/thumbnail/22.png`,
  },
  {
    id: 12,
    // "mapserver": "arcgis",
    dataset: "GLOFs in the High Mountain Asia",
    description: "",
    category: "Disaster",
    // "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/GLOF/MapServer",
    mapservice_rest_url: [
      {
        name: "GLOFs in the High Mountain Asia",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/GLOF/MapServer",
      },
    ],
    layerIndex: 0,
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=1973283",
    application_link:
      "https://icimod.maps.arcgis.com/apps/dashboards/2a7bb27f727542329c12c3f3da9b5bb8",
    paragraph:
      "Glacier lake outburst floods (GLOFs) have been intensely investigated in High Mountain Asia (HMA) in recent years and are the most well-known hazard associated with the cryosphere. The dataset presents the comprehensive inventory of GLOFs in HMA between 1833 and 2024, including details on the time of their occurrence, processes of lake formation and drainage involved as well as downstream impacts.",
    thumbnail: `${base}/images/thumbnail/12.png`,
  },
  {
    id: 23,
    // "mapserver": "arcgis",
    dataset: "Forest Fires in HKH",
    description: "",
    category: "Disaster",
    // "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Earthquake/MapServer",
    mapservice_rest_url: [],
    // "layerIndex":1,
    rds_link: "",
    application_link: "",
    paragraph:
      "This dataset showcases forest fire incidents in the HKH region from 2001 to 2023. The MODIS sensor on board Terra and Aqua satellites of NASA which provides active fire location at a 1 km spatial resolution is extensively used for monitoring forest fire across the globe. The forest fire dataset was prepared by overlaying the active fire data with the land cover data for HKH, facilitating the identification of forest fire occurrences in the region.",
    thumbnail: `${base}/images/thumbnail/23.png`,
  },
  {
    id: 18,
    // "mapserver": "arcgis",
    dataset: "Hydropower Plants in Nepal",
    description: "",
    category: "Energy",
    // "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/Hydropower/MapServer",
    mapservice_rest_url: [
      {
        name: "Operational",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/Hydropower/MapServer",
      },
      {
        name: "Under Construction",
        mapserver: "arcgis",
        layerIndex: 1,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/Hydropower/MapServer",
      },
      {
        name: "Planned",
        mapserver: "arcgis",
        layerIndex: 2,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Nepal/Hydropower/MapServer",
      },
    ],
    // "layerIndex":3,
    rds_link: "http://www.doed.gov.np/ ",
    application_link:
      "https://icimod.maps.arcgis.com/apps/dashboards/e599934a6b3649f4a5eb1e59c077bf6c",
    paragraph:
      "This dataset provides information about hydropower plants with capacity greater than 1MW in Nepal, categorized into three types: operational, under construction, and planned. The information was sourced from the Department of Electricity Development, Government of Nepal.",
    thumbnail: `${base}/images/thumbnail/18.png`,
  },
  {
    id: 11,
    // "mapserver": "arcgis",
    dataset: "Hydropower Plants in Bhutan",
    description: "",
    // "mapservice_rest_url": "",
    mapservice_rest_url: [
      {
        name: "Operational",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Hydropower/MapServer",
      },
      {
        name: "Under Construction",
        mapserver: "arcgis",
        layerIndex: 1,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Hydropower/MapServer",
      },
      {
        name: "Planned",
        mapserver: "arcgis",
        layerIndex: 2,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Hydropower/MapServer",
      },
    ],
    category: "Energy",
    // "layerIndex":0,
    rds_link: "",
    application_link: "",
    paragraph:
      "The dataset provides information on hydropower plants in Bhutan with capacity greater than 1MW categorized into three types: operational, under construction, and planned.",
    thumbnail: `${base}/images/thumbnail/11.png`,
  },

  {
    id: 14,
    // "mapserver": "arcgis",
    dataset: "Glacier Dynamics in Afghanistan",
    description: "",
    category: "Glacier",
    // "mapservice_rest_url": "",
    mapservice_rest_url: [],
    // "layerIndex":0,
    rds_link:
      "https://rds.icimod.org/Home/Data?any=glaciers%20of%20afghanistan%20servircat&Category=datasets",
    application_link: "https://geoapps.icimod.org/glacier/afglacier",
    paragraph:
      "This dataset provides information on glacier dynamics in Afghanistan between 1990 and 2015. The glacier data for 1990, 2000, 2010, and 2015 have been developed by ICIMOD under its SERVIR-HKH initiative using a uniform dataset (i.e. Landsat imageries) and methodology, which provide a scientific basis for understanding the changes taking place in the glacial environment of Afghanistan.",
    thumbnail: `${base}/images/thumbnail/14.png`,
  },
  {
    id: 15,
    mapserver: "arcgis",
    dataset: "Glacier Dynamics in Bhutan",
    description: "",
    category: "Glacier",
    // "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
    mapservice_rest_url: [
      {
        name: "Glacier 2010",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
      },
      {
        name: "Glacier 2000",
        mapserver: "arcgis",
        layerIndex: 1,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
      },
      {
        name: "Glacier 1990",
        mapserver: "arcgis",
        layerIndex: 2,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
      },
      {
        name: "Glacier 1980",
        mapserver: "arcgis",
        layerIndex: 3,
        url: "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Glacier/MapServer",
      },
    ],
    // "layerIndex":0,
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=9347",
    application_link: "https://geoapps.icimod.org/glacier/bhutanglacier/",
    paragraph:
      "This dataset maps glaciers in Bhutan as of 2010, created using Landsat TM and ETM+ imagery. The glacier outlines were derived through a semi-automated process involving the object-based image classification (OBIC) method, applied separately for clean ice and debris-covered areas. Further editing and validation were performed by overlaying the outlines on high-resolution images from Google Earth. ",
    thumbnail: `${base}/images/thumbnail/15.png`,
  },
  {
    id: 16,
    // "mapserver": "arcgis",
    dataset: "Forest Fires in Nepal",
    description: "",
    category: "Disaster",
    // "mapservice_rest_url": "https://geoapps.icimod.org/arcgis/rest/services/Nepal/NepalActiveFire/MapServer/",
    mapservice_rest_url: [
      {
        name: "Forest Fires in Nepal",
        mapserver: "arcgis",
        layerIndex: 1,
        url: "https://geoapps.icimod.org/arcgis/rest/services/Nepal/NepalActiveFire/MapServer/",
      },
    ],
    // "layerIndex":1,
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=8899",
    application_link: "http://nepal.spatialapps.net/NepalForestFire/EN",
    paragraph:
      "This dataset showcases forest fire incidents in Nepal from 2013 to 2024. The MODIS sensor on board Terra and Aqua satellites of NASA which provides active fire location at a 1 km spatial resolution is extensively used for monitoring forest fire across the globe. The forest fire dataset was prepared by overlaying the active fire data with Nepal’s land cover data, facilitating the identification of forest fire occurrences in the country.",
    thumbnail: `${base}/images/thumbnail/16.png`,
  },
  {
    id: 17,
    // "mapserver": "arcgis",
    dataset: "Forest Fires in Bhutan",
    description: "",
    category: "Disaster",
    // "mapservice_rest_url": "https://geoapps.icimod.org/arcgis/rest/services/Bhutan/BhutanActiveFire/MapServer",
    mapservice_rest_url: [
      {
        name: "Forest Fires in Bhutan",
        mapserver: "arcgis",
        layerIndex: 0,
        url: "https://geoapps.icimod.org/arcgis/rest/services/Bhutan/BhutanActiveFire/MapServer",
      },
    ],
    // "layerIndex":0,
    rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=28607",
    application_link: "https://geoapps.icimod.org/BhutanForestFire/FireStats/",
    paragraph:
      "This dataset showcases forest fire incidents in Bhutan from 2001 to 2024. The MODIS sensor on board Terra and Aqua satellites of NASA which provides active fire location at a 1 km spatial resolution is extensively used for monitoring forest fire across the globe. The forest fire dataset was prepared by overlaying the active fire data with Bhutan’s land cover data, facilitating the identification of forest fire occurrences in the country.",
    thumbnail: `${base}/images/thumbnail/17.png`,
    //   "paragraph":""
  },

  // {
  //   id: 19,
  //   mapserver: "geoserver",
  //   dataset: "Land cover of Nepal 2022",
  //   description: "",
  //   category: "Land Cover",
  //   // "mapservice_rest_url": "https://geoapps.icimod.org/geoserver/Nepal_LULC/wms",
  //   mapservice_rest_url: [
  //     {
  //       name: "Land Cover 2022",
  //       mapserver: "geoserver",
  //       layerIndex: "Nepal_LULC:landcover_2022",
  //       url: "https://geoapps.icimod.org/geoserver/Nepal_LULC/wms",
  //     },
  //   ],

  //   // "layerIndex":0,
  //   rds_link: "https://rds.icimod.org/Home/DataDetail?metadataId=1972729",
  //   application_link: "http://nepal.spatialapps.net/NLCMS",
  //   paragraph:
  //     "Land cover represents the earth’s terrestrial surface and subsurface features, including grass, trees, water, bare ground, human structures, etc. Changes in land cover affects water quality, watershed hydrology, habitat and species composition, climate and carbon storage, necessitating accurate data to monitor these changes and track associated environmental and anthropogenic variables. This dataset showcases the land cover distribution of Nepal for 2022. It is part of the annual land cover datasets (2000-2022) developed based on Landsat imagery of 30m spatial resolution under the National Land Cover Monitoring System (NLCMS) of Nepal. The NLCMS is developed by the Forest Research and Training Centre (FRTC), Nepal with support from ICIMOD through SERVIR Hindu Kush Himalaya (SERVIR-HKH), a joint initiative in partnership with NASA and USAID.",
  //   thumbnail:
  //     "https://rds.icimod.org/Content/metadataImage/1972700-1972799/1972729/public/MicrosoftTeams-image.png",
  // },

  // {
  //   "id": 20,
  //   "mapserver": "arcgis",
  //   "dataset": "Land Cover in Bhutan",
  //   "description": "Land cover of Bhutan 2010",
  //   "mapservice_rest_url": "https://geoapps.icimod.org/icimodarcgis/rest/services/Bhutan/Landcover/MapServer/",
  //   "layerIndex":4,
  //   "rds_link": "https://rds.icimod.org/Home/DataDetail?metadataId=8880",
  //   "application_link": "",
  //   "paragraph":"This dataset represents land cover of Bhutan for the year 2010. It was created using Landsat satellite imagery with a 30-meter spatial resolution.",
  //   "thumbnail": "https://rds.icimod.org/Content/metadataImage/08800-08899/8880/public/landcover_bhutan.png"
  // },WS
];

export const categories = [
  "Land Cover",
  "Disaster",
  "Glacier",
  "Energy",
  // "Other"
];

function createDatasetStore() {
  const { subscribe, set, update } = writable(initialDataset);

  return {
    subscribe,
    // Actions
    setDatasets: (datasets) => set(datasets),
    addDataset: (dataset) => update((datasets) => [...datasets, dataset]),
    removeDataset: (id) =>
      update((datasets) => datasets.filter((dataset) => dataset.id !== id)),
    updateDataset: (id, newData) =>
      update((datasets) =>
        datasets.map((dataset) =>
          dataset.id === id ? { ...dataset, ...newData } : dataset
        )
      ),
    // Getters
    getDatasetById: (id) => {
      let result;
      subscribe((datasets) => {
        result = datasets.find((dataset) => dataset.id === id);
      })();
      return result;
    },
    reset: () => set(initialDataset),
  };
}

export const datasetStore = createDatasetStore();
